import { createContext, useContext, useState } from "react";

const LanguageContext = createContext({ lang: "fr", setLang: () => {} });

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    try {
      return localStorage.getItem("roganel_lang") === "en" ? "en" : "fr";
    } catch {
      return "fr";
    }
  });

  const setLang = (l) => {
    try {
      localStorage.setItem("roganel_lang", l);
    } catch {}
    setLangState(l);
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
